/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInner,
  AssetTypeManufacturerModelResponseDto,
  CreateAssetRequestDto,
  ExecuteAssetOcppCommandRequestDto,
  ExecuteAssetOcppCommandResponseDto,
  ExtractHeadersResponseDto,
  GetAssetDetailsResponseDto,
  GetAssetOcppConfigurationResponseDto,
  GetAssetOcppSettingsResponseDto,
  GetAssetSummaryResponseDto,
  GetImportRequestResponseDto,
  GetImportRequestsResponseDto,
  ListAssetIncidentsResponseDto,
  ListAssetsResponseDto,
  OrganizationAssetControllerSuggestMappingsRequest,
  OrganizationAssetControllerUpload202Response,
  SetAssetOcppCredentialsRequestDto,
  UpdateAssetRequestDto,
} from '../models/index';
import {
    AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInnerFromJSON,
    AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInnerToJSON,
    AssetTypeManufacturerModelResponseDtoFromJSON,
    AssetTypeManufacturerModelResponseDtoToJSON,
    CreateAssetRequestDtoFromJSON,
    CreateAssetRequestDtoToJSON,
    ExecuteAssetOcppCommandRequestDtoFromJSON,
    ExecuteAssetOcppCommandRequestDtoToJSON,
    ExecuteAssetOcppCommandResponseDtoFromJSON,
    ExecuteAssetOcppCommandResponseDtoToJSON,
    ExtractHeadersResponseDtoFromJSON,
    ExtractHeadersResponseDtoToJSON,
    GetAssetDetailsResponseDtoFromJSON,
    GetAssetDetailsResponseDtoToJSON,
    GetAssetOcppConfigurationResponseDtoFromJSON,
    GetAssetOcppConfigurationResponseDtoToJSON,
    GetAssetOcppSettingsResponseDtoFromJSON,
    GetAssetOcppSettingsResponseDtoToJSON,
    GetAssetSummaryResponseDtoFromJSON,
    GetAssetSummaryResponseDtoToJSON,
    GetImportRequestResponseDtoFromJSON,
    GetImportRequestResponseDtoToJSON,
    GetImportRequestsResponseDtoFromJSON,
    GetImportRequestsResponseDtoToJSON,
    ListAssetIncidentsResponseDtoFromJSON,
    ListAssetIncidentsResponseDtoToJSON,
    ListAssetsResponseDtoFromJSON,
    ListAssetsResponseDtoToJSON,
    OrganizationAssetControllerSuggestMappingsRequestFromJSON,
    OrganizationAssetControllerSuggestMappingsRequestToJSON,
    OrganizationAssetControllerUpload202ResponseFromJSON,
    OrganizationAssetControllerUpload202ResponseToJSON,
    SetAssetOcppCredentialsRequestDtoFromJSON,
    SetAssetOcppCredentialsRequestDtoToJSON,
    UpdateAssetRequestDtoFromJSON,
    UpdateAssetRequestDtoToJSON,
} from '../models/index';

export interface AssetControllerGetAssetModelsMetadataByAssetTypeIdRequest {
    assetTypeId: string;
}

export interface AssetControllerGetManufacturerModelAssociationsByAssetTypeIdRequest {
    assetTypeId: string;
}

export interface OrganizationAssetControllerCreateAssetRequest {
    organizationId: string;
    createAssetRequestDto: CreateAssetRequestDto;
}

export interface OrganizationAssetControllerDeleteAssetByIdRequest {
    assetId: string;
    organizationId: string;
}

export interface OrganizationAssetControllerExecuteOcppCommandRequest {
    assetId: string;
    organizationId: string;
    executeAssetOcppCommandRequestDto: ExecuteAssetOcppCommandRequestDto;
}

export interface OrganizationAssetControllerExtractHeadersRequest {
    id: string;
    organizationId: string;
}

export interface OrganizationAssetControllerGetAssetDetailsByIdRequest {
    assetId: string;
    organizationId: string;
}

export interface OrganizationAssetControllerGetAssetOcppConfigurationRequest {
    assetId: string;
    organizationId: string;
}

export interface OrganizationAssetControllerGetAssetOcppSettingsRequest {
    assetId: string;
    organizationId: string;
}

export interface OrganizationAssetControllerGetAssetSummaryByIdRequest {
    assetId: string;
    organizationId: string;
}

export interface OrganizationAssetControllerGetByIdRequest {
    id: string;
    organizationId: string;
}

export interface OrganizationAssetControllerGetImportRequestsRequest {
    organizationId: string;
}

export interface OrganizationAssetControllerGetMappingRequest {
    organizationId: string;
}

export interface OrganizationAssetControllerListAssetIncidentsRequest {
    limit: number;
    page: number;
    assetId: string;
    organizationId: string;
}

export interface OrganizationAssetControllerListAssetsByOrganizationRequest {
    limit: number;
    page: number;
    organizationId: string;
    assetModelId?: string;
    assetTypeId?: string;
    q?: string;
}

export interface OrganizationAssetControllerRefreshAssetOcppConfigurationRequest {
    assetId: string;
    organizationId: string;
}

export interface OrganizationAssetControllerSetAssetOcppCredentialsRequest {
    assetId: string;
    organizationId: string;
    setAssetOcppCredentialsRequestDto: SetAssetOcppCredentialsRequestDto;
}

export interface OrganizationAssetControllerSuggestMappingsOperationRequest {
    organizationId: string;
    organizationAssetControllerSuggestMappingsRequest: OrganizationAssetControllerSuggestMappingsRequest;
}

export interface OrganizationAssetControllerUpdateAssetByIdRequest {
    assetId: string;
    organizationId: string;
    updateAssetRequestDto: UpdateAssetRequestDto;
}

export interface OrganizationAssetControllerUploadRequest {
    organizationId: string;
    file: Blob;
    assetTypeId: string;
    suggestions?: string;
    headers?: string;
    assetModelId?: string;
    availableFields?: string;
}

/**
 * 
 */
export class AssetApi extends runtime.BaseAPI {

    /**
     * List asset models for an asset type
     */
    async assetControllerGetAssetModelsMetadataByAssetTypeIdRaw(requestParameters: AssetControllerGetAssetModelsMetadataByAssetTypeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInner>>> {
        if (requestParameters['assetTypeId'] == null) {
            throw new runtime.RequiredError(
                'assetTypeId',
                'Required parameter "assetTypeId" was null or undefined when calling assetControllerGetAssetModelsMetadataByAssetTypeId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/assets/asset-types/{assetTypeId}/models`;
        urlPath = urlPath.replace(`{${"assetTypeId"}}`, encodeURIComponent(String(requestParameters['assetTypeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInnerFromJSON));
    }

    /**
     * List asset models for an asset type
     */
    async assetControllerGetAssetModelsMetadataByAssetTypeId(requestParameters: AssetControllerGetAssetModelsMetadataByAssetTypeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInner>> {
        const response = await this.assetControllerGetAssetModelsMetadataByAssetTypeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List allowed manufacturer × model associations for an asset type (asset create/edit)
     */
    async assetControllerGetManufacturerModelAssociationsByAssetTypeIdRaw(requestParameters: AssetControllerGetManufacturerModelAssociationsByAssetTypeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssetTypeManufacturerModelResponseDto>>> {
        if (requestParameters['assetTypeId'] == null) {
            throw new runtime.RequiredError(
                'assetTypeId',
                'Required parameter "assetTypeId" was null or undefined when calling assetControllerGetManufacturerModelAssociationsByAssetTypeId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/assets/asset-types/{assetTypeId}/manufacturer-models`;
        urlPath = urlPath.replace(`{${"assetTypeId"}}`, encodeURIComponent(String(requestParameters['assetTypeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssetTypeManufacturerModelResponseDtoFromJSON));
    }

    /**
     * List allowed manufacturer × model associations for an asset type (asset create/edit)
     */
    async assetControllerGetManufacturerModelAssociationsByAssetTypeId(requestParameters: AssetControllerGetManufacturerModelAssociationsByAssetTypeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssetTypeManufacturerModelResponseDto>> {
        const response = await this.assetControllerGetManufacturerModelAssociationsByAssetTypeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new asset
     */
    async organizationAssetControllerCreateAssetRaw(requestParameters: OrganizationAssetControllerCreateAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAssetDetailsResponseDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationAssetControllerCreateAsset().'
            );
        }

        if (requestParameters['createAssetRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createAssetRequestDto',
                'Required parameter "createAssetRequestDto" was null or undefined when calling organizationAssetControllerCreateAsset().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAssetRequestDtoToJSON(requestParameters['createAssetRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAssetDetailsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create a new asset
     */
    async organizationAssetControllerCreateAsset(requestParameters: OrganizationAssetControllerCreateAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAssetDetailsResponseDto> {
        const response = await this.organizationAssetControllerCreateAssetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sets deletedAt; serial may be reused by a new active asset. Requires assets:delete.
     * Soft-delete an asset
     */
    async organizationAssetControllerDeleteAssetByIdRaw(requestParameters: OrganizationAssetControllerDeleteAssetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling organizationAssetControllerDeleteAssetById().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationAssetControllerDeleteAssetById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sets deletedAt; serial may be reused by a new active asset. Requires assets:delete.
     * Soft-delete an asset
     */
    async organizationAssetControllerDeleteAssetById(requestParameters: OrganizationAssetControllerDeleteAssetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.organizationAssetControllerDeleteAssetByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Supported actions: Reset (Soft|Hard), ClearCache, GetLocalListVersion, GetConfiguration (curated keys), TriggerMessage (curated MessageTrigger), ChangeConfiguration (HeartbeatInterval only). Requires assets:update and a usable Primary CSMS. The CALL is sent by the ingestion replica that owns the charger session. EVIMO-originated results are not forwarded to Primary or Secondary CSMS. No automatic retry.
     * Send an OCPP command to a charger
     */
    async organizationAssetControllerExecuteOcppCommandRaw(requestParameters: OrganizationAssetControllerExecuteOcppCommandRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExecuteAssetOcppCommandResponseDto>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling organizationAssetControllerExecuteOcppCommand().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationAssetControllerExecuteOcppCommand().'
            );
        }

        if (requestParameters['executeAssetOcppCommandRequestDto'] == null) {
            throw new runtime.RequiredError(
                'executeAssetOcppCommandRequestDto',
                'Required parameter "executeAssetOcppCommandRequestDto" was null or undefined when calling organizationAssetControllerExecuteOcppCommand().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/ocpp-commands`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExecuteAssetOcppCommandRequestDtoToJSON(requestParameters['executeAssetOcppCommandRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExecuteAssetOcppCommandResponseDtoFromJSON(jsonValue));
    }

    /**
     * Supported actions: Reset (Soft|Hard), ClearCache, GetLocalListVersion, GetConfiguration (curated keys), TriggerMessage (curated MessageTrigger), ChangeConfiguration (HeartbeatInterval only). Requires assets:update and a usable Primary CSMS. The CALL is sent by the ingestion replica that owns the charger session. EVIMO-originated results are not forwarded to Primary or Secondary CSMS. No automatic retry.
     * Send an OCPP command to a charger
     */
    async organizationAssetControllerExecuteOcppCommand(requestParameters: OrganizationAssetControllerExecuteOcppCommandRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExecuteAssetOcppCommandResponseDto> {
        const response = await this.organizationAssetControllerExecuteOcppCommandRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Extract column headers from uploaded CSV/XLSX file
     */
    async organizationAssetControllerExtractHeadersRaw(requestParameters: OrganizationAssetControllerExtractHeadersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExtractHeadersResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling organizationAssetControllerExtractHeaders().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationAssetControllerExtractHeaders().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/import-requests/{id}/headers`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExtractHeadersResponseDtoFromJSON(jsonValue));
    }

    /**
     * Extract column headers from uploaded CSV/XLSX file
     */
    async organizationAssetControllerExtractHeaders(requestParameters: OrganizationAssetControllerExtractHeadersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExtractHeadersResponseDto> {
        const response = await this.organizationAssetControllerExtractHeadersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get asset details by id
     */
    async organizationAssetControllerGetAssetDetailsByIdRaw(requestParameters: OrganizationAssetControllerGetAssetDetailsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAssetDetailsResponseDto>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling organizationAssetControllerGetAssetDetailsById().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationAssetControllerGetAssetDetailsById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/details/{assetId}`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAssetDetailsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get asset details by id
     */
    async organizationAssetControllerGetAssetDetailsById(requestParameters: OrganizationAssetControllerGetAssetDetailsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAssetDetailsResponseDto> {
        const response = await this.organizationAssetControllerGetAssetDetailsByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the last successful GetConfiguration snapshot from PostgreSQL. When configurationFetchedAt is null (never fetched), this GET may contact the charger with an empty GetConfiguration payload (ADR-0029), persist the full snapshot on success, and return the saved result. Failures leave any prior snapshot unchanged. Requires assets:read.
     * Get saved OCPP configuration for an asset
     */
    async organizationAssetControllerGetAssetOcppConfigurationRaw(requestParameters: OrganizationAssetControllerGetAssetOcppConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAssetOcppConfigurationResponseDto>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling organizationAssetControllerGetAssetOcppConfiguration().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationAssetControllerGetAssetOcppConfiguration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/ocpp-configuration`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAssetOcppConfigurationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns the last successful GetConfiguration snapshot from PostgreSQL. When configurationFetchedAt is null (never fetched), this GET may contact the charger with an empty GetConfiguration payload (ADR-0029), persist the full snapshot on success, and return the saved result. Failures leave any prior snapshot unchanged. Requires assets:read.
     * Get saved OCPP configuration for an asset
     */
    async organizationAssetControllerGetAssetOcppConfiguration(requestParameters: OrganizationAssetControllerGetAssetOcppConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAssetOcppConfigurationResponseDto> {
        const response = await this.organizationAssetControllerGetAssetOcppConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns non-sensitive organization OCPP flags for asset UI. Requires assets:read and tenant access to the asset.
     * Get OCPP settings for the asset organization
     */
    async organizationAssetControllerGetAssetOcppSettingsRaw(requestParameters: OrganizationAssetControllerGetAssetOcppSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAssetOcppSettingsResponseDto>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling organizationAssetControllerGetAssetOcppSettings().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationAssetControllerGetAssetOcppSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/details/{assetId}/ocpp-settings`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAssetOcppSettingsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns non-sensitive organization OCPP flags for asset UI. Requires assets:read and tenant access to the asset.
     * Get OCPP settings for the asset organization
     */
    async organizationAssetControllerGetAssetOcppSettings(requestParameters: OrganizationAssetControllerGetAssetOcppSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAssetOcppSettingsResponseDto> {
        const response = await this.organizationAssetControllerGetAssetOcppSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get lightweight asset summary for header and shell
     */
    async organizationAssetControllerGetAssetSummaryByIdRaw(requestParameters: OrganizationAssetControllerGetAssetSummaryByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAssetSummaryResponseDto>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling organizationAssetControllerGetAssetSummaryById().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationAssetControllerGetAssetSummaryById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/summary`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAssetSummaryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get lightweight asset summary for header and shell
     */
    async organizationAssetControllerGetAssetSummaryById(requestParameters: OrganizationAssetControllerGetAssetSummaryByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAssetSummaryResponseDto> {
        const response = await this.organizationAssetControllerGetAssetSummaryByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get import request status/report
     */
    async organizationAssetControllerGetByIdRaw(requestParameters: OrganizationAssetControllerGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetImportRequestResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling organizationAssetControllerGetById().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationAssetControllerGetById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/import-requests/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetImportRequestResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get import request status/report
     */
    async organizationAssetControllerGetById(requestParameters: OrganizationAssetControllerGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetImportRequestResponseDto> {
        const response = await this.organizationAssetControllerGetByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List import requests for polling
     */
    async organizationAssetControllerGetImportRequestsRaw(requestParameters: OrganizationAssetControllerGetImportRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetImportRequestsResponseDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationAssetControllerGetImportRequests().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/import-requests`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetImportRequestsResponseDtoFromJSON(jsonValue));
    }

    /**
     * List import requests for polling
     */
    async organizationAssetControllerGetImportRequests(requestParameters: OrganizationAssetControllerGetImportRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetImportRequestsResponseDto> {
        const response = await this.organizationAssetControllerGetImportRequestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get AI suggestions for mapping CSV columns to database fields
     */
    async organizationAssetControllerGetMappingRaw(requestParameters: OrganizationAssetControllerGetMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationAssetControllerGetMapping().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/mapping-suggestions`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get AI suggestions for mapping CSV columns to database fields
     */
    async organizationAssetControllerGetMapping(requestParameters: OrganizationAssetControllerGetMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.organizationAssetControllerGetMappingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Requires assets:read and incidents:read. Tenant access is enforced via the asset organization.
     * List incidents linked to an asset via IncidentAffectedAsset
     */
    async organizationAssetControllerListAssetIncidentsRaw(requestParameters: OrganizationAssetControllerListAssetIncidentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAssetIncidentsResponseDto>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling organizationAssetControllerListAssetIncidents().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling organizationAssetControllerListAssetIncidents().'
            );
        }

        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling organizationAssetControllerListAssetIncidents().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationAssetControllerListAssetIncidents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/incidents`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAssetIncidentsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Requires assets:read and incidents:read. Tenant access is enforced via the asset organization.
     * List incidents linked to an asset via IncidentAffectedAsset
     */
    async organizationAssetControllerListAssetIncidents(requestParameters: OrganizationAssetControllerListAssetIncidentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAssetIncidentsResponseDto> {
        const response = await this.organizationAssetControllerListAssetIncidentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List assets for an organization
     */
    async organizationAssetControllerListAssetsByOrganizationRaw(requestParameters: OrganizationAssetControllerListAssetsByOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAssetsResponseDto>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling organizationAssetControllerListAssetsByOrganization().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling organizationAssetControllerListAssetsByOrganization().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationAssetControllerListAssetsByOrganization().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['assetModelId'] != null) {
            queryParameters['assetModelId'] = requestParameters['assetModelId'];
        }

        if (requestParameters['assetTypeId'] != null) {
            queryParameters['assetTypeId'] = requestParameters['assetTypeId'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAssetsResponseDtoFromJSON(jsonValue));
    }

    /**
     * List assets for an organization
     */
    async organizationAssetControllerListAssetsByOrganization(requestParameters: OrganizationAssetControllerListAssetsByOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAssetsResponseDto> {
        const response = await this.organizationAssetControllerListAssetsByOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Always sends GetConfiguration with an empty payload, replaces the stored snapshot only on success, and leaves the previous snapshot unchanged on failure. Requires assets:update.
     * Refresh OCPP configuration from the charger
     */
    async organizationAssetControllerRefreshAssetOcppConfigurationRaw(requestParameters: OrganizationAssetControllerRefreshAssetOcppConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAssetOcppConfigurationResponseDto>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling organizationAssetControllerRefreshAssetOcppConfiguration().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationAssetControllerRefreshAssetOcppConfiguration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/ocpp-configuration/refresh`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAssetOcppConfigurationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Always sends GetConfiguration with an empty payload, replaces the stored snapshot only on success, and leaves the previous snapshot unchanged on failure. Requires assets:update.
     * Refresh OCPP configuration from the charger
     */
    async organizationAssetControllerRefreshAssetOcppConfiguration(requestParameters: OrganizationAssetControllerRefreshAssetOcppConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAssetOcppConfigurationResponseDto> {
        const response = await this.organizationAssetControllerRefreshAssetOcppConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Provision or change OCPP charger password
     */
    async organizationAssetControllerSetAssetOcppCredentialsRaw(requestParameters: OrganizationAssetControllerSetAssetOcppCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAssetDetailsResponseDto>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling organizationAssetControllerSetAssetOcppCredentials().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationAssetControllerSetAssetOcppCredentials().'
            );
        }

        if (requestParameters['setAssetOcppCredentialsRequestDto'] == null) {
            throw new runtime.RequiredError(
                'setAssetOcppCredentialsRequestDto',
                'Required parameter "setAssetOcppCredentialsRequestDto" was null or undefined when calling organizationAssetControllerSetAssetOcppCredentials().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/ocpp-credentials`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SetAssetOcppCredentialsRequestDtoToJSON(requestParameters['setAssetOcppCredentialsRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAssetDetailsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Provision or change OCPP charger password
     */
    async organizationAssetControllerSetAssetOcppCredentials(requestParameters: OrganizationAssetControllerSetAssetOcppCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAssetDetailsResponseDto> {
        const response = await this.organizationAssetControllerSetAssetOcppCredentialsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get AI suggestions for mapping CSV columns to database fields
     */
    async organizationAssetControllerSuggestMappingsRaw(requestParameters: OrganizationAssetControllerSuggestMappingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationAssetControllerSuggestMappings().'
            );
        }

        if (requestParameters['organizationAssetControllerSuggestMappingsRequest'] == null) {
            throw new runtime.RequiredError(
                'organizationAssetControllerSuggestMappingsRequest',
                'Required parameter "organizationAssetControllerSuggestMappingsRequest" was null or undefined when calling organizationAssetControllerSuggestMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/mapping-suggestions`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationAssetControllerSuggestMappingsRequestToJSON(requestParameters['organizationAssetControllerSuggestMappingsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get AI suggestions for mapping CSV columns to database fields
     */
    async organizationAssetControllerSuggestMappings(requestParameters: OrganizationAssetControllerSuggestMappingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.organizationAssetControllerSuggestMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update editable asset fields
     */
    async organizationAssetControllerUpdateAssetByIdRaw(requestParameters: OrganizationAssetControllerUpdateAssetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAssetDetailsResponseDto>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling organizationAssetControllerUpdateAssetById().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationAssetControllerUpdateAssetById().'
            );
        }

        if (requestParameters['updateAssetRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateAssetRequestDto',
                'Required parameter "updateAssetRequestDto" was null or undefined when calling organizationAssetControllerUpdateAssetById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAssetRequestDtoToJSON(requestParameters['updateAssetRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAssetDetailsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update editable asset fields
     */
    async organizationAssetControllerUpdateAssetById(requestParameters: OrganizationAssetControllerUpdateAssetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAssetDetailsResponseDto> {
        const response = await this.organizationAssetControllerUpdateAssetByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload a CSV/XLSX asset file for import
     */
    async organizationAssetControllerUploadRaw(requestParameters: OrganizationAssetControllerUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationAssetControllerUpload202Response>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationAssetControllerUpload().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling organizationAssetControllerUpload().'
            );
        }

        if (requestParameters['assetTypeId'] == null) {
            throw new runtime.RequiredError(
                'assetTypeId',
                'Required parameter "assetTypeId" was null or undefined when calling organizationAssetControllerUpload().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        if (requestParameters['suggestions'] != null) {
            formParams.append('suggestions', requestParameters['suggestions'] as any);
        }

        if (requestParameters['headers'] != null) {
            formParams.append('headers', requestParameters['headers'] as any);
        }

        if (requestParameters['assetTypeId'] != null) {
            formParams.append('assetTypeId', requestParameters['assetTypeId'] as any);
        }

        if (requestParameters['assetModelId'] != null) {
            formParams.append('assetModelId', requestParameters['assetModelId'] as any);
        }

        if (requestParameters['availableFields'] != null) {
            formParams.append('availableFields', requestParameters['availableFields'] as any);
        }


        let urlPath = `/api/v1/organizations/{organizationId}/assets/upload`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationAssetControllerUpload202ResponseFromJSON(jsonValue));
    }

    /**
     * Upload a CSV/XLSX asset file for import
     */
    async organizationAssetControllerUpload(requestParameters: OrganizationAssetControllerUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationAssetControllerUpload202Response> {
        const response = await this.organizationAssetControllerUploadRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
